export default __webpack_public_path__ + "static/media/Boat-Club.4d41e30d.jpg";